<mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
  <mat-expansion-panel-header class="custom-header">
    <mat-panel-title>
      {{Title}} - {{Expanded}}
    </mat-panel-title>
  </mat-expansion-panel-header>

  <p>
    <label class="mat-h2">Selecione o tipo de Documento: </label>
  </p>
  <br/>
  <br/>
  <ng-content></ng-content>
</mat-expansion-panel>